import React from 'react';
import './hamburguer-menu.scss';

const HamburguerMenu = ({onClick}) =>{
    return  <i className="pi pi-bars menu-sidebar-hamburguer" onClick={ onClick } />
}

export default React.memo(HamburguerMenu)